import { Modal, Form, Button } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { deleteInternshipJob } from "../../../actions/internshipJobPostingActions";
import Project from "./project";
import GalkButton from "../../common/component/button";

function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

const DeleteProjectModal = ({
	modalCloseHandler,
	isActionProgress,
	projectDetails,
	deleteInternshipJob,
}) => {
	const { t } = useTranslation();
	const prevActionInProgressValue = usePrevious(isActionProgress);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			modalCloseHandler();
		}
	}, [isActionProgress]);

	const deleteJob = () => {
		deleteInternshipJob(projectDetails.jobId);
		modalCloseHandler();
	};

	return (
		<Modal
			title={t("deleteProject_confirm_modalHeader", {
				projectNumber: projectDetails.index || "",
			})}
			visible={true}
			onCancel={modalCloseHandler}
			width={785}
			footer={null}
		>
			<Project
				project={projectDetails}
				index={projectDetails.index}
				readOnly={true}
			/>
			<div className="project-form-controls-cont">
				<GalkButton type="primary" width={180} onClick={deleteJob}>
					{t("deleteProject_confirm_modalAction_submit")}
				</GalkButton>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.galkLabJobs.actionInProgress,
});

export default connect(mapStateToProps, { deleteInternshipJob })(
	DeleteProjectModal
);
